import React from 'react';
import {
  styled,
  Icon,
  ThemeType,
  Spin,
  Container,
  NewColors,
} from '@erecruit/ui-kit';

const getColor = (theme: ThemeType, color: NewColors) => theme.newColors[color];

const InfoIconFactory = (color: NewColors) =>
  styled(Icon)(({ theme }) => ({
    '&.anticon.icon': {
      fontSize: 50,
      color: theme.newColors[color],
      position: 'absolute',
      top: 25,
      left: 25,
    },
  }));

const IconCircle = styled.div({
  width: 100,
  height: 100,
  borderRadius: '50%',
  position: 'relative',
  opacity: 0.2,
});

const IconCircleFactory = (color: NewColors) =>
  styled(IconCircle)(({ theme }) => ({
    backgroundColor: getColor(theme, color),
  }));

const SuccessStyledIcon = InfoIconFactory('statusSuccess');
const ErrorStyledIcon = InfoIconFactory('statusCritical');

const SuccessIconCircle = IconCircleFactory('statusSuccess');
const ErrorIconCircle = IconCircleFactory('statusCritical');

const SuccessInfo = () => (
  <Container overflow="hidden" position="relative" background="pageSecondary">
    <SuccessIconCircle />
    <SuccessStyledIcon type="check" />
  </Container>
);

const ErrorInfo = () => (
  <Container overflow="hidden" position="relative" background="pageSecondary">
    <ErrorIconCircle />
    <ErrorStyledIcon type="action-error" />
  </Container>
);

const LoadingInfo = styled(IconCircle)(({ theme }) => ({
  border: '10px solid',
  borderColor: '#eff5ff',
  borderLeftColor: getColor(theme, 'statusStandard'),
  animation: `${Spin} 1.1s infinite linear`,
}));

export { SuccessInfo, ErrorInfo, LoadingInfo };
